import { Node } from "tiptap";

export default class ColumnNode extends Node {
  get name() {
    return "column";
  }

  get schema() {
    return {
      content: "block+",
      isolating: true,
      defining: true,
      parseDOM: [
        { tag: 'div[data-type="column"]' },
        { tag: "div.rte-column" },
      ],
      toDOM: () => ["div", { "data-type": "column", class: "rte-column" }, 0],
    };
  }
}
